<template>
  <div>
    <ul class="fixedBox">
      <li @mousemove="hoverIndex(0)">
        <img src="https://image.ceekee.com/pc/tripwise/fixed3.png" />
        <div
          class="floatBox contact"
          :class="[{ 'first-child-show': isHover && !isClose }, { 'first-child-close': isClose }]"
        >
          <div class="b-flex b-flex-bettwen b-align-centenr">
            <span>联系我们</span>
            <img
              class="guanbi-img"
              @click="closeHover"
              src="https://image.ceekee.com/pc/tripwise/icon_close_darkGrey_20.png"
            />
          </div>
          {{ this.$config.phone_number }}
          <br />188-3573-0716
        </div>
      </li>
      <li @mousemove="hoverIndex(1)">
        <img src="https://image.ceekee.com/pc/tripwise/fixed1.png" />
        <div class="floatBox">
          <!-- <img src="https://image.ceekee.com/pc/secondwebsite/erweima_zixun.png" /> -->
          <img src="https://image.ceekee.com/pc/secondwebsite/img_qr.png" />
          <p>
            在线咨询
            <br />
            <b>微信扫一扫</b>
          </p>
        </div>
      </li>
      <li>
        <a @click="toApply" href="javascript:void(0)">
          <img src="https://image.ceekee.com/pc/tripwise/fixed4.png" />
        </a>
      </li>
    </ul>
    <div class="online-service-box" @click="openOnlineService">
      <img class="online-service-img" src="https://image.ceekee.com/pc/tripwise/img_home_onlineservice.png" alt="" />
      <div class="online-service-text">在线客服</div>
    </div>
  </div>
</template>
<script>
import YSF from "@neysf/qiyu-web-sdk";

export default {
  data() {
    return {
      isHover: true,
      isClose: false,
    };
  },
  created() {
    let hover = window.localStorage.getItem("contactHoverNotShow") || 0;
    if (hover == 1) {
      this.isHover = false;
    }
  },
  methods: {
    hoverIndex(index) {
      if (index == 0) {
        if (this.isClose) {
          return;
        }
        this.isHover = true;
        this.isClose = false;
      } else {
        this.isHover = false;
      }
    },
    closeHover() {
      this.isHover = false;
      this.isClose = true;
      window.localStorage.setItem("contactHoverNotShow", 1);
      setTimeout(() => {
        this.isClose = false;
      }, 1000);
    },
    toApply() {
      this.$router.push("/apply");
    },
    openOnlineService() {
      this.BaiduReportData();
      YSF.init("38faac50e515bdef64d1ddd9acd9fe30", {
        // templateId: 123, // templateId表示自定义会话邀请的模板标识
        // shuntId: 123, // shuntId表示访客选择多入口分流模版id
        // sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 0, // hidden表示是否隐藏访客端默认入口
      })
        .then((ysf) => {
          ysf("open");
        })
        .catch((error) => {
          console.log("sdk加载失败---", error);
        });
    },
    //转化追踪埋点
    async BaiduReportData() {
      const conversionTypes = [1, 51, 92].map((newType) => ({ logidUrl: window.location.href, newType }));
      await this.$BaiduReportData.sendData(conversionTypes);
    },
  },
};
</script>
<style lang="less" scoped>
.guanbi-img {
  height: 16px !important;
  width: 16px !important;
  float: right !important;
  margin-top: 5px !important;
  margin: 0 !important;
}
.fixedBox {
  width: 50px;
  background: #007aff;
  border-radius: 7px;
  position: fixed;
  right: 20px;
  top: 180px;
  li {
    padding: 18px 0 0;
    cursor: pointer;
    position: relative;
    &:hover {
      background: rgba(31, 12, 12, 0.1);
      .floatBox {
        left: -260px;
      }
    }
    img {
      width: 25px;
      display: block;
      margin: 0 auto;
      padding-bottom: 18px;
      border-bottom: 1px solid rgba(241, 241, 241, 0.3);
    }
    &:last-child {
      a > img {
        border-bottom: none;
      }
    }
    .floatBox {
      position: absolute;
      transition: all 1s;
      width: 260px;
      border-radius: 4px;
      left: 260px;
      top: 0;
      background: #fff;
      box-shadow: 0px 0px 16px rgba(229, 229, 229, 0.5);
      color: #000;
      font-size: 16px;
      img {
        width: 100px;
        float: left;
        border-radius: 7px;
        padding-bottom: 0;
      }
      p {
        width: 120px;
        text-align: center;
        float: left;
        margin: 25px 0 0 10px;
        font-size: 17px;
        line-height: 25px;
        color: #222222;
      }
      &.contact {
        top: 50%;
        padding: 10px 20px;
        margin-top: -53px;
        width: 240px;
      }
    }
    .first-child-show {
      left: -260px !important;
    }
    .first-child-close {
      left: 260px !important;
    }
  }
}
.online-service-box {
  width: 50px;
  background: #1022a2;
  border-radius: 27.5px;
  position: fixed;
  right: 20px;
  top: 380px;
  padding: 10px 0;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  .online-service-img {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .online-service-text {
    font-size: 12px;
    color: #fff;
    line-height: 14px;
    margin-top: 10px;
    padding: 0 10px;
  }
}
</style>
